import React from 'react';
import PropTypes from 'prop-types';
// import getLineItemsFromInvoices from '../getLineItemsFromInvoices';
import ServiceItem from './ServiceItem';

class ServicesProvided extends React.PureComponent {
  getLineItemsFromInvoices = invoices => {
    let lineItems = []; // create an array of line items

    invoices.forEach(invoice => {
      if (invoice.lineItems && invoice.lineItems.length && invoice.lineItems.length > 0) {
        invoice.lineItems.forEach(lineItem => lineItems.push(lineItem));
      }
    });

    return lineItems;
  };

  render() {
    const { contract, currencySymbol } = this.props;
    let lineItems = this.getLineItemsFromInvoices(contract.invoices);
    let lineItemsExist = lineItems && lineItems.length && lineItems.length > 0;
    return (
      <div className="contract-html">
        {lineItemsExist && <h3>SERVICES PROVIDED & PRICING:</h3>}
        {lineItemsExist
          && lineItems.map((item, i) => {
            let key = item.title + item.amount + item.description;
            return <ServiceItem key={key + i} item={item} currencySymbol={currencySymbol} />;
          })}
      </div>
    );
  }
}

ServicesProvided.propTypes = {
  contractFlow: PropTypes.object,
};

// Specifies the default values for props:
ServicesProvided.defaultProps = {
  contractFlow: {},
};

export default ServicesProvided;



// WEBPACK FOOTER //
// ./src/components/common/ContractComponent/ServicesAndPayment/ServicesProvided/index.js